import * as React from 'react';
import styled from 'styled-components';

import { Popover } from '../material-ui';

const Box = styled(Popover).attrs({
	anchorOrigin: { vertical: 'top', horizontal: 'center' },
	transformOrigin: { vertical: 'bottom', horizontal: 'center' },
})``;

const Wrapper = styled.div`
	padding: 0.5rem 1.5rem;
`;

export class Infobox extends React.Component {
	state = { open: false };

	setAnchorRef = (node) => {
		this.anchor = node;
	};

	handleOpen = () => this.setState({ open: true });
	handleClose = () => this.setState({ open: false });

	render = () =>
		this.props.content ? (
			<React.Fragment>
				<Box open={this.state.open} onClose={this.handleClose} anchorEl={this.anchor}>
					<Wrapper>{this.props.content}</Wrapper>
				</Box>
				<span ref={this.setAnchorRef} onClick={this.handleOpen}>
					{this.props.children}
				</span>
			</React.Fragment>
		) : (
			this.props.children
		);
}



// WEBPACK FOOTER //
// ./src/components/Infobox.js